import "./AnswerRights.module.css";
import Header from "@/reusable_sections/Header";
import RightOfReply from "./sections/RightOfReply";
import Footer from "@/reusable_sections/Footer";
export default function AnswerRightsPage() {
  return <div>
      <Header />
      <RightOfReply />
      <Footer />
    </div>;
}